import { useStore } from 'zustand';
import { useEditAreaDraftStore } from '@/entities/edit-area';

/**
 * 인쇄 영역 지우기 — 사진 위 Delete 키와 사이드바 [인쇄 영역 삭제]가 함께 쓴다.
 * 이 면에 놓인 영역이면 확인 없이 이 면에서 지우고(다른 면 어디에도 없으면 인쇄 영역까지) 선택을 푼다.
 * 이 면에 놓이지 않은 영역(사이드바에서만 지울 수 있다)은 연결 배치 수로 확인받고 인쇄 영역을 지운다.
 * 지우면(또는 확인 창에서 그만두면) null, 거부되면 사유를 돌려준다.
 */
export const useRemoveArea = (): ((componentId: string) => string | null) => {
  const store = useEditAreaDraftStore();
  const state = useStore(store);
  return (componentId) => {
    const face = state.selection.face;
    const placed =
      state.faces[face]?.placements.some((item) => item.componentId === componentId) ?? false;
    if (placed) {
      if (!state.removeAreaFromFace(face, componentId))
        return store.getState().commandError ?? '인쇄 영역을 지울 수 없습니다.';
      state.setSelection({ componentId: null });
      return null;
    }
    const component = state.components.find((item) => item.id === componentId);
    if (component === undefined) return '인쇄 영역을 찾을 수 없습니다.';
    const count = Object.values(state.faces).reduce(
      (sum, value) =>
        sum + value.placements.filter((item) => item.componentId === componentId).length,
      0,
    );
    if (!window.confirm(`${component.name} 인쇄 영역과 연결된 배치 ${count}개를 삭제하시겠습니까?`))
      return null;
    return state.removeComponent(componentId)
      ? null
      : (store.getState().commandError ?? '인쇄 영역을 지울 수 없습니다.');
  };
};
